// src/pages/contract-template.jsx
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { Worker, Viewer } from '@react-pdf-viewer/core'; // PDF Viewer
import { GlobalWorkerOptions } from 'pdfjs-dist';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

import axiosInstance from '~/utils/axiosInstance'; // Your custom Axios instance
import contractTypesFrontEnd from './contract/contractTypes'; // Import contract data

// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import Title from '../components/common/title';
import { ScrollRestoration } from 'react-router-dom';

//import './contract-template.css';

// Set the workerSrc globally
GlobalWorkerOptions.workerSrc = 'https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js';

const ContractTemplate = () => {

  const { contractType } = useParams();
  const [contractData, setContractData] = useState({});

  useEffect(()=>{

    const fetchContractTemplates = async () => {
      try {
        const response = await axiosInstance.get(`/api/contract/contract-templates`);
        const contractTemplates = response.data;
        console.log('contractTemplates:', contractTemplates);
        let thisContractData = contractTemplates.filter(c=>c.name===contractType)[0];
        console.log('thisContractData1:', thisContractData);
        thisContractData = {...contractTypesFrontEnd[contractType], ...thisContractData};
        console.log('thisContractData2:', thisContractData);
        setContractData(prevData => thisContractData);
      } catch (error) {
        console.error('Error retrieving contract template:', error);
        return false;
      }
    }

    fetchContractTemplates();
  },[contractType])

  //const contractData = contractTypesFrontEnd[contractType];

  if (!contractData) {
    return (
      <div style={{ padding:'10rem', display:'flex', justifyContent:'center' }}>
        <p>沒有此種合約類型</p>
      </div>
    )
  }

  const [pdfUrl, setPdfUrl] = useState(null);
  const [isPurchaseModalOpen, setIsPurchaseModalOpen] = useState(false);
  const togglePurchaseModal = () => setIsPurchaseModalOpen(!isPurchaseModalOpen);
  const [isPurchasing, setIsPurchasing] = useState(false);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth); // Track window width

  // Create new plugin instance
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  // Fetch the PDF file from the backend
  const fetchPdf = async (filename, isPreview = true) => {
    console.log('filename:', filename);
    if(filename){
      try {
        const endpoint = isPreview ? 
          `/api/contract/contract-templates/pdfs/preview/${filename}.pdf` : 
          `/api/contract/contract-templates/pdfs/${filename}.pdf`;
        const response = await axiosInstance.get(endpoint, { responseType: 'blob' });
        const fileUrl = URL.createObjectURL(response.data);
        setPdfUrl(fileUrl);
      } catch (error) {
        if (error.response?.status === 403) {
          console.error('Access denied. Please purchase this contract template.');
        } else {
          console.error('Error fetching PDF:', error);
        }
      }
    }
  };

  // Check if the user has access to the contract
  const checkAccess = async () => {
    try {
      const response = await axiosInstance.get(`/api/contract/contract-templates/access/${contractData._id}`);
      return response.data.hasAccess;
    } catch (error) {
      console.error('Error checking access:', error);
      return false;
    }
  };

  // Handle contract download
  const handleDownload = async () => {
    const hasAccess = await checkAccess();

    if (hasAccess) {
      // Fetch and download the full PDF
      console.log('downloading:', contractData.pdfName);
      const response = await axiosInstance.get(`/api/contract/contract-templates/pdfs/${contractData.pdfName}.pdf`, 
        { responseType: 'blob' }
      );
      const url = URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${contractData.title}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      // Prompt the user to purchase
      togglePurchaseModal();
    }
  };

  // Handle purchase confirmation
  const handlePurchase = async () => {
    try {
      setIsPurchasing(true);
      const response = await axiosInstance.post(`/api/contract/contract-templates/purchase/${contractData.id}`);
      if (response.data.success) {
        toggleModal();
        handleDownload(); // Automatically download after purchase
      } else {
        console.error('Purchase failed:', response.data.message);
      }
    } catch (error) {
      console.error('Error purchasing contract:', error);
    } finally {
      setIsPurchasing(false);
    }
  };

  // Fetch the PDF initially
  useEffect(() => {
    fetchPdf(contractData.pdfName);

    // Cleanup Object URL on unmount
    return () => {
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl);
      }
    };
  }, [contractType, contractData.pdfName]);

  // Update on window resize
  useEffect(() => {
    let timeoutId;

    const handleResize = () => {
      // Use debounce to reduce the frequency of handling resize events
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        const newWidth = window.innerWidth;

        if (newWidth !== windowWidth) {
          setWindowWidth(newWidth);
          fetchPdf(contractData.pdfName); // Refetch only if width changes
        }
      }, 200); // Adjust debounce delay as needed
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(timeoutId);
    };
  }, [windowWidth, contractData.pdfName]);

  return (
    <>
      {/* <PageTitle link={"合約範本"} pageName={"合約範本"} /> */}
      <div className="team-area pages-style">

        <div style={{ 
          backgroundColor: '#c9e8e6',
          padding: '42px 30px 15px 30px',
          margin: '0px 0px 30px 0px'
        }}>
          <Title 
            sectionName={contractData.title}
            sectionTitle={contractData.description}
            sectionNameColor="black"
            sectionTitleColor="black"
            sectionNameFontSize="25px"
            sectionTitleFontSize="18px"
            sectionNameFontWeight="500"
            sectionTitleFontWeight="300"
            style={"style-2"}
          />
        </div>

        <div className="container" style={{ paddingBottom:'5rem' }}>

          {/* Flex container for PDF and description */}
          <Row>
            {/* Left: PDF Viewer */}
            <Col 
              xs={12} lg={8}
              className="pdf-viewer" 
              style={{ 
                border: '1px solid #ddd', padding: '10px', backgroundColor: '#f9f9f9',
                //borderBottom: '1px solid #ddd',
                maxHeight:'32rem',
                minHeight:'30rem',
                marginBottom:'2rem'
              }}
            >
              {pdfUrl ? (
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                  {/*<Viewer fileUrl={pdfUrl} plugins={[defaultLayoutPluginInstance]} />*/}
                  <Viewer fileUrl={pdfUrl} />
                </Worker>
              ) : (
                <p>Loading PDF...</p>
              )}
            </Col>


            {/* Right: Descriptions */}
            <Col 
              xs={12} lg={4}
              className="description"
              style={{ padding: '10px 50px' }}
            >
              <div style={{ marginBottom:'1.5rem' }}>
                <Button 
                  color="outline-info" 
                  onClick={handleDownload}
                  style={{ marginRight:'0.5rem', marginBottom:'0.5rem' }}
                >下載合約</Button>
                <Button color="outline-warning"
                  style={{ marginBottom:'0.5rem' }}
                >AI 填空（開發中）</Button>
              </div>
              <div>
                <h5>合約類型：{contractData.title}</h5>
                <p style={{ fontSize: '14px', color: '#9f9d9d' }}>
                  下載所需點數：
                    {contractData.downloadPoints==='免費' ? 
                      `${contractData.downloadPoints}` :
                      `${contractData.downloadPoints} 點`
                    }
                </p>
                <p>{contractData.description}</p>
                <ul>
                  {contractData && contractData?.details && contractData.details.map((detail, index) => (
                    <li key={index}>{detail}</li>
                  ))}
                </ul>
              </div>
            </Col>

          </Row>

        </div>
        <div className="bg-ellipse"></div>
      </div>

      {/* Purchase Modal */}
      <Modal isOpen={isPurchaseModalOpen} toggle={togglePurchaseModal}>
        <ModalHeader toggle={togglePurchaseModal}>購買合約</ModalHeader>
        <ModalBody>
          您尚未購買此合約範本，是否要花費 {contractData.downloadPoints} 點來購買？
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handlePurchase} disabled={isPurchasing}>
            {isPurchasing ? '購買中...' : '確定購買'}
          </Button>{' '}
          <Button color="secondary" onClick={togglePurchaseModal}>
            取消
          </Button>
        </ModalFooter>
      </Modal>

      <ScrollRestoration />
    </>
  );
};

export default ContractTemplate;

